import React from 'react';
import { Link } from 'gatsby';
import { Activity } from 'lucide-react';

import { StaticSearchQueries } from '../../../../lib/queries/search/static-search.queries';

type DefaultSearchFormProps = {
  setSearchQuery: (string) => void;
};

const DefaultSearchForm = ({ setSearchQuery }): DefaultSearchFormProps => {

  return (
    <div className='space-y-4 px-2 py-4'>
      <div>
        <div className='mb-2 px-2 text-xs font-semibold uppercase text-slate-600 dark:text-slate-300'>
          Suggestions
        </div>
        <ul>
          {StaticSearchQueries.map((searchQuery) => {
            return (
              <li key={searchQuery.name}>
                <Link
                  className='group flex items-center rounded px-2 py-1 text-sm leading-6 outline-none focus-within:bg-slate-50 hover:bg-slate-50 dark:focus-within:bg-slate-800 dark:hover:bg-slate-800 text-black dark:text-white'
                  to={searchQuery.href}
                >
                  <Activity
                    size={12}
                    className='fill-slate-400 dark:fill-slate-600 mr-3 group-hover:animate-pulse group-hover:scale-125'
                  />
                  <span>{searchQuery.name}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
export default DefaultSearchForm;
